export const modalsConstants = {
  SHOW_CHANGE_EMAIL_MODAL: "SHOW_CHANGE_EMAIL_MODAL",
  HIDE_CHANGE_EMAIL_MODAL: "HIDE_CHANGE_EMAIL_MODAL",
};
